export default "__VITE_ASSET__3JOBoFgP__"